module.exports = __webpack_public_path__ + "img/science-case.dca1e80c.png";